module.exports = __webpack_public_path__ + "img/loading.e99b1e0c.gif";